import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { validateToken } from '../services/apiService';
import useAutoLogout from '../pages/Login/autoLogout';

const AuthRoute = () => {
  const [isValid, setIsValid] = useState(null);
  const token = localStorage.getItem('token');
  useAutoLogout();

  useEffect(() => {
    const checkToken = async () => {
      if (!token) {
        setIsValid(false);
        return;
      }

      const valid = await validateToken();
      setIsValid(valid);
    };

    checkToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isValid === null) return <div>Loading...</div>;

  if (isValid) {
    return <Navigate to="/asset/search" replace />;
  }

  return <Outlet />;
};

export default AuthRoute;
